import { Seo } from '@/lib/metadata/getMeta';
import { ImageNode } from '@/types/global';
import { Author, PostsACF } from '@/types/blog/single';
import { Account, BrokerFields } from '@/types/brokers/slug';
import { PageInfoProps } from '@/types/brokers/page';
import { CommentNode } from '@/components/(postTypes)/platforms/(archive)/layout/(review)/list/Reviews';
import { LayoutProps } from '@/types/generalSettings';
import { GoldFields } from '@/types/gold/page';
export interface ExchangesProps {
    allExchange?: {
        nodes: Exchange[];
        pageInfo: PageInfoProps;
    };
    goldPlatforms?: {
        nodes: Exchange[];
        pageInfo: PageInfoProps;
    };
    banners?: LayoutProps.Banners;
    exchangeForeignAd?: Exchange[];
    exchangeIranianAd?: Exchange[];
    propAd?: Exchange[];
    props?: {
        nodes: Exchange[];
        pageInfo: PageInfoProps;
    };
    pageBy?: PageBy;
    error?: string;
    lastModifiedData?: Exchange[];
    comments?: {
        nodes: CommentNode[];
        pageInfo: { hasNextPage: boolean; endCursor: string };
    };
}

export interface PageBy {
    title?: string;
    date?: string;
    databaseId?: number;
    slug?: string;
    commentCount?: number;
    content?: string;
    author?: Author;
    seo?: Seo;
    posts_acf?: PostsACF;
    featuredImage?: ImageNode | null;
    exchangesListPage?: ExchangesListPage | null;
}
interface AdList {
    databaseId: number; // Each ad has a databaseId
}
export interface ExchangesListPage {
    ads?: AdList[];
    banners?: Banner[];
    aparatHnembed: string;
    youtubeHnembed: string;
    exchangesBrokers: Exchange[];
}
export interface Banner {
    linkId: string;
    link: {
        url: string;
    };
    image: {
        altText: string;
        sourceUrl: string;
    };
}
export interface ExchangeList {
    brokers?: BrokerMain;
    props?: BrokerMain;
    allExchange?: BrokerMain;
}
export interface BrokerMain {
    nodes: Exchange[];
}
export interface Exchange {
    databaseId: number;
    title: string;
    slug: string;
    uri: string;
    commentCount?: number;
    postRatings: PostRatings;
    brokerSingle: BrokerSingle;
    brokerFields?: BrokerFields;
    exchangeFields?: BrokerFields;
    goldFields?: GoldFields;
}

export interface PostRatings {
    average: number;
    count: number;
}

export interface BrokerSingle {
    newfields: NewFields;
}

export interface NewFields {
    about: string;
    badge: string;
    sponsored: boolean;
    verified: boolean;
    contact: Contact;
    ctaButton: CTAButton;
    enName: string;
    extraButtons: ExtraButton[];
    ctaId: string;
    moreButtonId: string;
    faName: string;
    subtitle: string;
    logo: Logo;
    rank: number;
    rating?: { value: number }[];
}

export interface Contact {
    address: string;
    email: string;
    phone: string;
    website: Website;
}

export interface Website {
    target: string;
    title: string;
    url: string;
}

export interface CTAButton {
    target: string;
    title: string;
    url: string;
}

export interface ExtraButton {
    title: string;
    url: string;
}

export interface Logo {
    mediaItemUrl: string;
}

export interface Rating {
    title: string;
    value: number;
}
export interface ExchangeFields {
    generalInfo: GeneralInfo;
    account: Account | Account[];
    tutorialTitle?: string;
    tutorialBlock?: TutorialBlock[];
}
export interface TutorialBlock {
    tabTitle: string;
    tabContent: TabContent[];
}
export interface TabContent {
    title: string;
    text: string;
    image: contentImage;
}
export interface contentImage {
    mediaDetails: imageDetail;
    sourceUrl?: string;
    title?: string;
}
export interface imageDetail {
    size: {
        width: string;
        height: string;
    };
}
export interface GeneralInfo {
    coinsNum: string;
    instantAuth: boolean;
    leverageSupport: boolean;
    rank: string;
    year: string;
    country: Country;
    customFeature: CustomFeature[];
    exchangeRating?: {
        finalRating: string;
    };
    brokerRating?: {
        finalRating: string;
    };
}
export interface Country {
    nameEn: string;
    nameFa: string;
}
export interface CustomFeature {
    title: string;
    value: string;
}
// utils/labels.ts
export const exchangeFarsiLabels: Record<string, string> = {
    nameFa: 'کشور',
    leverageSupport: 'معاملات اهرم دار',
    instantAuth: 'احراز هویت آنی',
    coinsNum: 'تعداد ارز دیجیتال',
    year: 'سال تاسیس',
    customFeature: 'ویژگی سفارشی',
};
